import React, { useState } from "react";

const LoopProperty = ({ Data }) => {
  const [ShowFull, setShowFull] = useState(false);
  const [SelectedImage, setSelectedImage] = useState(Data.images[0].url);
  return (
    <div style={{ marginBottom: "3rem" }}>
      <h4>{Data.propertyAddress}</h4>
      <p className="text-grey">
        <span className="mr-1">
          <b>Bedrooms:</b> {Data.bedrooms}
        </span>
        <span className="mr-1">
          <b>Bathrooms:</b> {Data.bathrooms}
        </span>
        <span className="mr-1">
          <b>Price:</b> £{Data.price}
        </span>
      </p>
      <p dangerouslySetInnerHTML={{ __html: Data.shortDescription }}></p>
      {ShowFull && <p dangerouslySetInnerHTML={{ __html: Data.fullDescription }}></p>}
      {!ShowFull && (
        <p className="link" onClick={() => setShowFull(true)}>
          More...
        </p>
      )}

      <div className="flex-row">
        <div className="two-thirds">
          {Data.images.map((itm, idx) => (
            <img
              key={idx}
              className="thumb link"
              src={itm.url}
              alt="Thumbnail"
              onClick={() => setSelectedImage(itm.url)}
            />
          ))}
        </div>
        <div className="one-third">{SelectedImage > "" && <img src={SelectedImage} alt="Main" className="main" />}</div>
      </div>
    </div>
  );
};

export default LoopProperty;
